import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import logo from "../../assets/logo.png";

// Replace this with your actual Authservice function
import { verifyLogin2FA } from "../../service/Authservice";

function TwoFactorSetup() {
  const navigate = useNavigate();

  const [qrData, setQrData] = useState({
    qrCodeUrl: "",
    secret: "",
  });

  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const pendingData = sessionStorage.getItem("pendingAdmin2FA");

    if (!pendingData) {
      navigate("/", { replace: true });
      return;
    }

    try {
      const parsed = JSON.parse(pendingData);

      const admin = parsed?.admin || {};

      setQrData({
        qrCodeUrl: admin?.qrCodeUrl || "",
        secret: admin?.secret || admin?.twoFactorSecret || "",
      });

      // If QR is not returned, setup cannot continue
      if (!admin?.qrCodeUrl) {
        navigate("/", { replace: true });
      }
    } catch (err) {
      sessionStorage.removeItem("pendingAdmin2FA");
      navigate("/", { replace: true });
    }
  }, [navigate]);

  const handleVerify = async () => {
    if (!verificationCode.trim()) {
      setError("Please enter the verification code.");
      setOpen(true);
      return;
    }

    if (!/^\d{6}$/.test(verificationCode)) {
      setError("Please enter a valid 6-digit verification code.");
      setOpen(true);
      return;
    }

    try {
      setLoading(true);

      const pendingData = JSON.parse(sessionStorage.getItem("pendingAdmin2FA"));

      if (!pendingData?.tempToken) {
        throw new Error("Two-factor session expired. Please login again.");
      }

      const payload = {
        code: verificationCode,
        tempToken: pendingData.tempToken,
      };

      const response = await verifyLogin2FA(payload);

      console.log("2FA setup response:", response);

      /*
       * QR setup is now complete.
       *
       * IMPORTANT:
       * Do NOT save admin.token here and automatically login.
       *
       * We want:
       *
       * Setup complete
       *      ↓
       * Login again
       *      ↓
       * Enter authenticator code
       *      ↓
       * Dashboard
       */

      sessionStorage.removeItem("pendingAdmin2FA");

      localStorage.removeItem("Data");
      localStorage.removeItem("ntk");
      localStorage.removeItem("userId");
      localStorage.removeItem("permissions");

      navigate("/", {
        replace: true,
        state: {
          message:
            "Two-factor authentication enabled successfully. Please login again.",
        },
      });
    } catch (err) {
      console.error("2FA verification error:", err);

      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Invalid verification code.",
      );

      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <div className="App">
      <div className="Auth-logo">
        <img src={logo} className="logo_img" alt="Wally Market" />
      </div>

      <div className="twofactor-page">
        <div className="twofactor-setup">
          <h2>Set Up Two-Factor Authentication</h2>

          <div className="qr-section">
            <p>
              Scan the QR code with your authenticator app (Google
              Authenticator, Authy, etc.)
            </p>

            <img src={qrData.qrCodeUrl} alt="QR Code" />

            <div className="form-group">
              <label>Verification Code</label>

              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                value={verificationCode}
                onChange={(e) =>
                  setVerificationCode(e.target.value.replace(/\D/g, ""))
                }
                placeholder="Enter 6-digit code"
              />
            </div>

            <button
              className="btn-primary"
              onClick={handleVerify}
              disabled={loading || verificationCode.length !== 6}
            >
              {loading ? "Verifying..." : "Verify & Enable"}
            </button>
          </div>
        </div>
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert variant="filled" severity="error" onClose={handleClose}>
            {error}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

export default TwoFactorSetup;
